import {
  APIBusinessCriticalFieldsResponse,
  APIPriorityViewpointsResponse,
  ArdoqId,
  PersistedEntityGroupShape,
} from '@ardoq/api-types';
import { isArdoqError } from '@ardoq/common-helpers';
import { crudApi, fetchJson, Method, toRequestOptions } from './api';
import { ApiResponse } from './types';

export const PRIORITY_VIEWPOINTS_ENTITY_GROUP_NAME = 'Priority Viewpoints';

const fetchBusinessCriticalFields = async () => {
  const request = new Request(`/api/entity-group/business-critical-fields`);
  return fetchJson<APIBusinessCriticalFieldsResponse>(request);
};

const updateBusinessCriticalFields = async (
  fieldIds: string[],
  componentTypeIds: string[]
): ApiResponse<APIBusinessCriticalFieldsResponse> => {
  const request = new Request(
    `/api/entity-group/business-critical-fields`,
    toRequestOptions(Method.PUT, {
      fieldIds,
      componentTypeIds,
    })
  );
  return fetchJson<APIBusinessCriticalFieldsResponse>(request);
};

const fetchPriorityViewpointIds = async (): ApiResponse<ArdoqId[]> => {
  const request = new Request(`/api/entity-group/priority-viewpoints`);
  const result = await fetchJson<APIPriorityViewpointsResponse>(request);
  if (isArdoqError(result)) return result;
  return result.viewpointIds;
};

const updatePriorityViewpointIds = async (
  viewpointIds: ArdoqId[]
): ApiResponse<ArdoqId[]> => {
  const request = new Request(
    `/api/entity-group/priority-viewpoints`,
    toRequestOptions(Method.PUT, { viewpointIds })
  );
  const result = await fetchJson<APIPriorityViewpointsResponse>(request);
  if (isArdoqError(result)) return result;
  return result.viewpointIds;
};

export const entityGroupApi = {
  ...crudApi<PersistedEntityGroupShape>('entity-group'),
  fetchBusinessCriticalFields,
  updateBusinessCriticalFields,
  fetchPriorityViewpointIds,
  updatePriorityViewpointIds,
};
